module.exports = __webpack_public_path__ + "static/media/fast-food-french-svgrepo-com.8746ebce.svg";